
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Receipt, Users, GraduationCap, BookOpen, TrendingUp, Calendar, Search, ArrowUpDown, IndianRupee, Clock, FileDown, Settings2, CreditCard, Info, X, ChevronLeft, ChevronRight, Mail, Phone, Percent, Building2, AlertCircle, CheckCircle2, Download, Filter, Package, Truck, Monitor, ExternalLink, ChevronDown, FileText, Archive } from '../DeskeyIcons';
// import { Button } from '../ui/button';
// import { toast } from 'sonner';

// const API = process.env.REACT_APP_BACKEND_URL;

// const STATUS_FALLBACK = {
//   400: 'Bad request.',
//   401: 'Please sign in again to continue.',
//   402: 'Not enough Super Credits for this action.',
//   403: "You don't have access to this resource.",
//   404: 'Not found.',
//   409: 'Conflict — please refresh and try again.',
//   413: 'That file is too large.',
//   422: 'Some inputs are invalid.',
//   429: 'Too many requests — please slow down.',
//   500: 'Server error. Please try again in a moment.',
//   502: 'Upstream service is busy. Please retry.',
//   503: 'Service temporarily unavailable.',
//   504: 'Request timed out. Please retry.',
// };

// const api = async (path, opts = {}) => {
//   const token = localStorage.getItem('desky_token');
//   const res = await fetch(`${API}/api${path}`, { ...opts, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...opts.headers } });

//   let text = '';
//   try {
//     text = await res.clone().text();
//   } catch {
//     try { text = await res.text(); } catch { text = ''; }
//   }

//   let body = null;
//   if (text) {
//     try { body = JSON.parse(text); }
//     catch { body = { _raw: text }; }
//   }

//   if (!res.ok) {
//     const detail =
//       (body && (body.detail || body.message || body._raw)) ||
//       STATUS_FALLBACK[res.status] ||
//       `Request failed (${res.status})`;
//     const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
//     err.status = res.status;
//     err.body = body;
//     throw err;
//   }
//   return body;
// };
// const apiRaw = async (path) => {
//   const token = localStorage.getItem('desky_token');
//   return fetch(`${API}/api${path}`, { headers: { Authorization: `Bearer ${token}` } });
// };

// const fmt = (v) => `₹${(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
// const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '--';

// /* ── Profile Info Modal ── */
// function UserInfoModal({ person, accent, onClose }) {
//   if (!person) return null;
//   const A = accent;
//   const Row = ({ icon: Icon, label, value }) => (
//     <div className="flex items-center gap-3 py-3 px-1">
//       <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${A}10` }}>
//         <Icon className="w-4 h-4" style={{ color: A }} />
//       </div>
//       <div className="min-w-0 flex-1">
//         <p className="text-[11px] text-gray-500 font-medium uppercase tracking-wider">{label}</p>
//         <p className="text-sm text-gray-900 font-medium truncate">{value || '--'}</p>
//       </div>
//     </div>
//   );
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="billing-profile-modal">
//       <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
//       <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
//         <div className="h-28 relative" style={{ background: `linear-gradient(135deg, ${A}, ${A}cc)` }}>
//           <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors" data-testid="close-billing-modal"><X className="w-4 h-4 text-white" /></button>
//         </div>
//         <div className="flex justify-center -mt-14">
//           <div className="w-28 h-28 rounded-full border-4 border-white shadow-lg flex items-center justify-center text-white text-3xl font-bold" style={{ background: A }}>{(person.full_name || '?')[0].toUpperCase()}</div>
//         </div>
//         <div className="text-center mt-3 px-6">
//           <h3 className="text-lg font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>{person.full_name}</h3>
//           <span className={`inline-block mt-1 text-[11px] px-3 py-0.5 rounded-full font-semibold border ${person.role === 'teacher' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{person.role}</span>
//         </div>
//         <div className="px-6 mt-3 space-y-0 divide-y divide-slate-100">
//           <Row icon={Mail} label="Email" value={person.email} />
//           <Row icon={Phone} label="Phone" value={person.phone} />
//           <Row icon={Clock} label="Licence Duration" value={`${person.licence_duration_months} months`} />
//           <Row icon={IndianRupee} label="Base Cost (Desky)" value={fmt(person.base_cost)} />
//           {person.role === 'student' && person.markup_total > 0 && <Row icon={TrendingUp} label="Institution Markup" value={fmt(person.markup_total)} />}
//           <Row icon={Percent} label="GST (18%)" value={`CGST ${fmt(person.cgst)} + SGST ${fmt(person.sgst)}`} />
//           <Row icon={IndianRupee} label="Grand Total" value={fmt(person.total_with_gst)} />
//           <Row icon={Calendar} label="Activated" value={fmtDate(person.activated_at)} />
//           <Row icon={Calendar} label="Expires" value={fmtDate(person.expires_at)} />
//         </div>
//         <div className="px-6 pb-5 pt-4">
//           <button onClick={onClose} className="w-full h-10 rounded-xl text-sm font-semibold text-gray-600 border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors" data-testid="close-profile-btn">Close</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ── Billing Settings Panel ── */
// function BillingSettingsPanel({ settings, accent, onSave, onClose }) {
//   const [form, setForm] = useState({ ...settings });
//   const [saving, setSaving] = useState(false);
//   const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
//   const handleSave = async () => {
//     setSaving(true);
//     await onSave(form);
//     setSaving(false);
//   };
//   const fields = [
//     { key: 'gstin', label: 'GSTIN Number', placeholder: 'e.g. 29AABCU9603R1ZM', desc: 'Your 15-digit GST Identification Number' },
//     { key: 'billing_name', label: 'Legal Entity Name', placeholder: 'e.g. ABC School Trust', desc: 'Name as on GST registration' },
//     { key: 'billing_address', label: 'Billing Address', placeholder: 'Street address', desc: null },
//     { key: 'billing_city', label: 'City', placeholder: 'City', desc: null },
//     { key: 'billing_state', label: 'State', placeholder: 'State', desc: null },
//     { key: 'billing_pin', label: 'PIN Code', placeholder: '6-digit PIN', desc: null },
//     { key: 'student_markup', label: 'Student Markup (per month)', placeholder: '0', type: 'number', desc: 'Extra amount you charge each student per month on top of Desky base cost' },
//     { key: 'hsn_sac_code', label: 'HSN/SAC Code', placeholder: '998431', desc: 'Service classification code for invoicing' },
//   ];
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="billing-settings-modal">
//       <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
//       <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in fade-in zoom-in-95 duration-200 max-h-[90vh] overflow-y-auto">
//         <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10">
//           <div>
//             <h3 className="text-base font-bold text-gray-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Billing & GST Settings</h3>
//             <p className="text-xs text-gray-500 mt-0.5">Configure your GST details and student markup</p>
//           </div>
//           <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center"><X className="w-4 h-4 text-gray-500" /></button>
//         </div>
//         <div className="px-6 py-5 space-y-4">
//           {fields.map(f => (
//             <div key={f.key}>
//               <label className="text-xs font-semibold text-gray-700">{f.label}</label>
//               {f.desc && <p className="text-[11px] text-gray-500 mt-0.5 mb-1">{f.desc}</p>}
//               <input
//                 type={f.type || 'text'}
//                 value={form[f.key] || ''}
//                 onChange={e => set(f.key, f.type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
//                 placeholder={f.placeholder}
//                 className="w-full h-10 mt-1 px-3 text-sm rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent bg-white transition-shadow"
//                 style={{ '--tw-ring-color': `${accent}40` }}
//                 data-testid={`bs-${f.key}`}
//               />
//             </div>
//           ))}
//           <div className="bg-gray-50 rounded-xl p-4 mt-3 border border-gray-100">
//             <p className="text-xs text-gray-600 font-semibold mb-2">Desky Base Rates (Fixed)</p>
//             <div className="grid grid-cols-3 gap-3 text-sm">
//               <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
//                 <p className="text-[10px] text-gray-500 font-medium">Teacher</p>
//                 <p className="text-sm font-bold text-gray-800">{fmt(settings.rate_teacher || 500)}<span className="text-[10px] text-gray-500 font-normal">/mo</span></p>
//               </div>
//               <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
//                 <p className="text-[10px] text-gray-500 font-medium">Student</p>
//                 <p className="text-sm font-bold text-gray-800">{fmt(settings.rate_student || 200)}<span className="text-[10px] text-gray-500 font-normal">/mo</span></p>
//               </div>
//               <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
//                 <p className="text-[10px] text-gray-500 font-medium">GST</p>
//                 <p className="text-sm font-bold text-gray-800">18%</p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="sticky bottom-0 bg-white border-t border-gray-100 px-6 py-3 flex gap-3">
//           <button onClick={onClose} className="flex-1 h-10 rounded-xl text-sm font-medium text-gray-600 border border-gray-200 hover:bg-gray-50 transition-colors">Cancel</button>
//           <Button onClick={handleSave} disabled={saving} className="flex-1 h-10 rounded-xl text-sm font-semibold text-white shadow" style={{ background: accent }} data-testid="bs-save">
//             {saving ? 'Saving...' : 'Save Settings'}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ── Stat Card ── */
// function StatCard({ label, value, sub, icon: Icon, color, alert, testId }) {
//   return (
//     <div className={`bg-white border rounded-xl shadow p-4 flex flex-col justify-between transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 group ${alert ? 'border-red-200 bg-red-50/30' : 'border-gray-200'}`} data-testid={testId}>
//       <div className="flex items-center justify-between mb-3">
//         <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${color}12` }}>
//           <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.75} />
//         </div>
//         <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 text-right leading-tight max-w-[80px]">{label}</span>
//       </div>
//       <div>
//         <p className="text-xl font-extrabold text-gray-900 tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{value}</p>
//         <p className="text-[11px] text-gray-500 mt-0.5 truncate">{sub}</p>
//       </div>
//     </div>
//   );
// }

// const TABS = [
//   { id: 'overview', label: 'Overview', icon: Receipt },
//   { id: 'line-items', label: 'Line Items', icon: Users },
//   { id: 'payments', label: 'Payments', icon: CreditCard },
// ];

// export function InvoicesSection({ accent }) {
//   const A = accent || '#34A853';
//   const [tab, setTab] = useState('overview');
//   const [summary, setSummary] = useState(null);
//   const [items, setItems] = useState([]);
//   const [settings, setSettings] = useState(null);
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [settingsOpen, setSettingsOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);

//   // Line items state
//   const [liSearch, setLiSearch] = useState('');
//   const [liRole, setLiRole] = useState('all');
//   const [liStatus, setLiStatus] = useState('all');
//   const [liPage, setLiPage] = useState(1);
//   const [liTotal, setLiTotal] = useState(0);
//   const [liTotalPages, setLiTotalPages] = useState(1);
//   const [liSort, setLiSort] = useState('activated');
//   const [liDir, setLiDir] = useState('desc');
//   const [downloading, setDownloading] = useState(false);
//   const [invoiceMenuOpen, setInvoiceMenuOpen] = useState(false);

//   // Current year
//   const currentYear = new Date().getFullYear();
//   const [selectedYear, setSelectedYear] = useState(currentYear.toString());

//   const loadSummary = useCallback(async () => {
//     const [s, bs] = await Promise.all([
//       api('/institution/invoices/summary'),
//       api('/institution/billing/settings'),
//     ]);
//     setSummary(s);
//     setSettings(bs);
//   }, []);

//   const loadLineItems = useCallback(async () => {
//     let url = `/institution/invoices/line-items?page=${liPage}&page_size=50`;
//     if (liRole !== 'all') url += `&role=${liRole}`;
//     if (liStatus !== 'all') url += `&status=${liStatus}`;
//     if (liSearch) url += `&search=${encodeURIComponent(liSearch)}`;
//     const res = await api(url);
//     setItems(res.items || []);
//     setLiTotal(res.total_count || 0);
//     setLiTotalPages(res.total_pages || 1);
//   }, [liPage, liRole, liStatus, liSearch]);

//   const loadPayments = useCallback(async () => {
//     const res = await api('/institution/billing/payments');
//     setPayments(res.payments || []);
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([loadSummary(), loadLineItems(), loadPayments()]).finally(() => setLoading(false));
//   }, [loadSummary, loadLineItems, loadPayments]);

//   useEffect(() => { if (!loading) loadLineItems(); }, [liPage, liRole, liStatus, liSearch]);
//   useEffect(() => setLiPage(1), [liRole, liStatus, liSearch]);

//   const handleSaveSettings = async (form) => {
//     await api('/institution/billing/settings', { method: 'PUT', body: JSON.stringify(form) });
//     toast.success('Billing settings saved');
//     setSettingsOpen(false);
//     loadSummary();
//     loadLineItems();
//   };

//   const downloadPDF = async (endpoint, filename) => {
//     setDownloading(true);
//     setInvoiceMenuOpen(false);
//     try {
//       const res = await apiRaw(endpoint);
//       if (!res.ok) { toast.error('Failed to generate PDF'); setDownloading(false); return; }
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = filename;
//       a.click();
//       URL.revokeObjectURL(url);
//       toast.success('Invoice downloaded');
//     } catch { toast.error('Download failed'); }
//     setDownloading(false);
//   };

//   const handlePayNow = async (paymentType = 'plan') => {
//     try {
//       const due = paymentType === 'overage' ? summary?.extra_licence_dues : summary?.pending_dues;
//       if (!summary || due <= 0) {
//         toast.error(paymentType === 'overage' ? 'No extra licence dues to pay' : 'No pending dues to pay');
//         return;
//       }

//       const user = JSON.parse(localStorage.getItem('desky_user') || '{}');

//       const paymentData = await api(`/institution/billing/create-payment?payment_type=${paymentType}`, { method: 'POST' });

//       const options = {
//         key: paymentData.key_id,
//         amount: paymentData.amount,
//         currency: paymentData.currency,
//         name: 'Deskey',
//         description: paymentType === 'overage' ? 'Extra Licence Payment' : 'License & Storage Payment',
//         order_id: paymentData.razorpay_order_id,
//         handler: async (response) => {
//           try {
//             await api('/institution/billing/verify-payment', {
//               method: 'POST',
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//               }),
//             });
//             toast.success('Payment successful!');
//             loadSummary();
//             loadPayments();
//           } catch (err) {
//             toast.error('Payment verification failed');
//           }
//         },
//         prefill: {
//           name: user.full_name || '',
//           email: user.email || '',
//         },
//         theme: { color: '#3b82f6' },
//         modal: {
//           ondismiss: () => {
//             toast.info('Payment cancelled');
//           },
//         },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       if (err.status === 400 && err.body?.detail?.includes('not configured')) {
//         toast.error('Razorpay payment gateway is not configured. Please contact Desky support.');
//       } else {
//         notifyError(err.body, 'Failed to initiate payment');
//       }
//     }
//   };

//   const sorted = useMemo(() => {
//     let list = [...items];
//     list.sort((a, b) => {
//       let va, vb;
//       if (liSort === 'name') { va = a.full_name || ''; vb = b.full_name || ''; }
//       else if (liSort === 'cost') { va = a.total_with_gst || 0; vb = b.total_with_gst || 0; }
//       else if (liSort === 'base') { va = a.base_cost || 0; vb = b.base_cost || 0; }
//       else { va = a.activated_at || ''; vb = b.activated_at || ''; }
//       if (va < vb) return liDir === 'asc' ? -1 : 1;
//       if (va > vb) return liDir === 'asc' ? 1 : -1;
//       return 0;
//     });
//     return list;
//   }, [items, liSort, liDir]);

//   const toggleSort = (col) => {
//     if (liSort === col) setLiDir(d => d === 'asc' ? 'desc' : 'asc');
//     else { setLiSort(col); setLiDir('desc'); }
//   };

//   if (loading || !summary) {
//     return (
//       <div className="flex items-center justify-center h-[calc(100vh-120px)]" data-testid="invoices-loading">
//         <div className="text-center">
//           <div className="w-10 h-10 border-2 border-gray-200 border-t-slate-500 rounded-full animate-spin mx-auto mb-3" />
//           <p className="text-sm text-gray-500">Loading billing data...</p>
//         </div>
//       </div>
//     );
//   }

//   const teacherCount = summary.total_teachers || 0;
//   const studentCount = summary.total_students || 0;

//   return (
//     <div className="flex flex-col gap-4 h-[calc(100vh-120px)]" data-testid="invoices-section">
//       {selectedUser && <UserInfoModal person={selectedUser} accent={A} onClose={() => setSelectedUser(null)} />}
//       {settingsOpen && settings && <BillingSettingsPanel settings={settings} accent={A} onSave={handleSaveSettings} onClose={() => setSettingsOpen(false)} />}

//       {/* ── Top Stats Row ── */}
//       <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 flex-shrink-0" data-testid="invoices-stat-cards">
//         <StatCard label="Desky Dues" value={fmt(summary.desky_base_total)} icon={IndianRupee} color={A}
//           sub={`${teacherCount}T + ${studentCount}S licensed`} testId="stat-desky-dues" />
//         <StatCard label="GST 18%" value={fmt(summary.gst_total)} icon={Percent} color="#ef4444"
//           sub={`CGST ${fmt(summary.cgst)} + SGST ${fmt(summary.sgst)}`} testId="stat-gst" />
//         <StatCard label="Total Payable" value={fmt(summary.desky_payable)} icon={Receipt} color="#3b82f6"
//           sub="Base + GST to Desky" testId="stat-total-payable" />
//         <StatCard label="Earnings" value={fmt(summary.school_markup_total)} icon={TrendingUp} color="#8b5cf6"
//           sub={summary.school_markup_per_student > 0 ? `${fmt(summary.school_markup_per_student)}/student/mo` : 'No markup set'} testId="stat-earnings" />
//         <StatCard label="Pending" value={fmt(summary.pending_dues)} icon={CreditCard}
//           color={summary.pending_dues > 0 ? '#ef4444' : '#10b981'}
//           sub={summary.paid_total > 0 ? `Paid: ${fmt(summary.paid_total)}` : 'No payments yet'}
//           alert={summary.pending_dues > 0} testId="stat-pending" />
//       </div>

//       {/* ── Tabs + Actions ── */}
//       <div className="flex items-center gap-3 flex-shrink-0 flex-wrap">
//         <div className="flex gap-1 bg-gray-100 rounded-xl p-1">
//           {TABS.map(t => (
//             <button key={t.id} onClick={() => setTab(t.id)}
//               className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all ${tab === t.id ? 'bg-white shadow text-gray-900' : 'text-gray-600 hover:text-gray-800'}`}
//               data-testid={`inv-tab-${t.id}`}>
//               <t.icon className="w-3.5 h-3.5" strokeWidth={tab === t.id ? 2 : 1.5} />
//               {t.label}
//             </button>
//           ))}
//         </div>
//         <div className="ml-auto flex gap-2">
//           <Button onClick={() => setSettingsOpen(true)} variant="outline" className="h-9 px-3.5 text-xs font-semibold rounded-lg border-gray-200 gap-1.5" data-testid="open-billing-settings">
//             <Settings2 className="w-3.5 h-3.5" />Settings
//           </Button>
//           <div className="flex gap-2">
//             <select
//               value={selectedYear}
//               onChange={(e) => setSelectedYear(e.target.value)}
//               className="h-9 px-3 text-xs font-semibold rounded-lg border border-gray-200 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#34A853]"
//               data-testid="year-selector"
//             >
//               <option value={currentYear.toString()}>{currentYear}</option>
//               <option value={(currentYear - 1).toString()}>{currentYear - 1}</option>
//             </select>
//             <div className="relative">
//               <Button onClick={() => setInvoiceMenuOpen(v => !v)} disabled={downloading} variant="outline" className="h-9 px-3.5 text-xs font-semibold rounded-lg border-gray-200 gap-1.5" data-testid="download-invoice-btn">
//                 <Download className="w-3.5 h-3.5" />{downloading ? 'Generating...' : 'Download'}<ChevronDown className="w-3 h-3 ml-0.5" />
//               </Button>
//             </div>
//             {invoiceMenuOpen && (
//               <>
//                 <div className="fixed inset-0 z-40" onClick={() => setInvoiceMenuOpen(false)} />
//                 <div className="absolute right-0 top-11 z-50 w-72 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden animate-in fade-in zoom-in-95 duration-150" data-testid="invoice-download-menu">
//                   {/* Full Licence Invoice */}
//                   <div className="px-3 pt-3 pb-1.5">
//                     <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Licence Invoices</p>
//                   </div>
//                   <button onClick={() => downloadPDF('/institution/billing/generate-invoice-pdf', 'desky_licence_invoice.pdf')}
//                     className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-full-licence">
//                     <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0"><FileText className="w-4 h-4 text-blue-500" /></div>
//                     <div className="min-w-0"><p className="text-sm font-medium text-gray-800">Full Licence Invoice</p><p className="text-[11px] text-gray-500">All users, complete GST breakdown</p></div>
//                   </button>

//                   {/* Yearly */}
//                   <div className="px-3 pt-3 pb-1.5 border-t border-gray-100">
//                     <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Yearly</p>
//                   </div>
//                   <button onClick={() => downloadPDF(`/institution/billing/generate-invoice-pdf?period=${selectedYear}`, `desky_invoice_${selectedYear}.pdf`)}
//                     className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-yearly">
//                     <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center flex-shrink-0"><Calendar className="w-4 h-4 text-violet-500" /></div>
//                     <div className="min-w-0"><p className="text-sm font-medium text-gray-800">{selectedYear} Annual Invoice</p><p className="text-[11px] text-gray-500">Full year summary</p></div>
//                   </button>

//                   {/* Device Purchases */}
//                   {summary?.device_order_count > 0 && (
//                     <>
//                       <div className="px-3 pt-3 pb-1.5 border-t border-gray-100">
//                         <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Device Purchases</p>
//                       </div>
//                       <button onClick={() => downloadPDF('/institution/billing/generate-device-invoice-pdf', 'desky_device_invoice.pdf')}
//                         className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-device-purchases">
//                         <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0"><Monitor className="w-4 h-4 text-amber-500" /></div>
//                         <div className="min-w-0"><p className="text-sm font-medium text-gray-800">Device Purchase Invoice</p><p className="text-[11px] text-gray-500">{summary.device_order_count} orders — {fmt(summary.device_order_total)}</p></div>
//                       </button>
//                     </>
//                   )}

//                   <div className="h-1.5" />
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ─── OVERVIEW TAB ─── */}
//       {tab === 'overview' && (
//         <div className="bg-white border border-gray-200 rounded-xl shadow flex-1 min-h-0 overflow-y-auto" data-testid="overview-content">
//           <div className="p-5 space-y-5">

//             {/* Billing Summary Grid */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
//               {/* Left: Cost Breakdown */}
//               <div className="space-y-4">
//                 <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider flex items-center gap-2">
//                   <IndianRupee className="w-4 h-4 text-gray-500" />Cost Breakdown
//                 </h3>
//                 <div className="bg-gray-50 rounded-xl border border-gray-100 divide-y divide-slate-100">
//                   {summary.billing_model === 'plan' ? (
//                     <>
//                       <div className="flex items-center justify-between p-3.5">
//                         <div className="flex items-center gap-3">
//                           <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center"><Package className="w-4 h-4 text-violet-500" /></div>
//                           <div>
//                             <p className="text-sm font-medium text-gray-800">{summary.plan_name} Plan</p>
//                             <p className="text-[11px] text-gray-500">{fmt(summary.plan_price_per_license)}/licence x {(summary.plan_license_limit || 0).toLocaleString('en-IN')} licence limit</p>
//                           </div>
//                         </div>
//                         <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.plan_total_cost)}</p>
//                       </div>
//                       <div className="flex items-center justify-between p-3.5">
//                         <div className="flex items-center gap-3">
//                           <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center"><BookOpen className="w-4 h-4 text-blue-500" /></div>
//                           <div>
//                             <p className="text-sm font-medium text-gray-800">Teacher Licences</p>
//                             <p className="text-[11px] text-gray-500">{teacherCount} teachers — always free</p>
//                           </div>
//                         </div>
//                         <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(0)}</p>
//                       </div>
//                       <div className="flex items-center justify-between p-3.5">
//                         <div className="flex items-center gap-3">
//                           <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center"><GraduationCap className="w-4 h-4 text-emerald-500" /></div>
//                           <div>
//                             <p className="text-sm font-medium text-gray-800">Licensed seats used</p>
//                             <p className="text-[11px] text-gray-500">{summary.plan_licensed_count || 0} of {(summary.plan_license_limit || 0).toLocaleString('en-IN')}</p>
//                           </div>
//                         </div>
//                       </div>
//                       {summary.extra_licence_dues > 0 && (
//                         <div className="flex items-center justify-between p-3.5">
//                           <div className="flex items-center gap-3">
//                             <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center"><AlertCircle className="w-4 h-4 text-amber-500" /></div>
//                             <div>
//                               <p className="text-sm font-medium text-gray-800">Extra licence dues</p>
//                               <p className="text-[11px] text-gray-500">Beyond plan limit, prorated to renewal</p>
//                             </div>
//                           </div>
//                           <p className="text-sm font-bold text-amber-600 tabular-nums">{fmt(summary.extra_licence_dues)}</p>
//                         </div>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       <div className="flex items-center justify-between p-3.5">
//                         <div className="flex items-center gap-3">
//                           <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center"><BookOpen className="w-4 h-4 text-blue-500" /></div>
//                           <div>
//                             <p className="text-sm font-medium text-gray-800">Teacher Licences</p>
//                             <p className="text-[11px] text-gray-500">{teacherCount} teachers x {fmt(summary.rate_teacher || 0)}/mo x {summary.avg_teacher_months || 12}mo</p>
//                           </div>
//                         </div>
//                         <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_teacher_cost)}</p>
//                       </div>
//                       <div className="flex items-center justify-between p-3.5">
//                         <div className="flex items-center gap-3">
//                           <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center"><GraduationCap className="w-4 h-4 text-emerald-500" /></div>
//                           <div>
//                             <p className="text-sm font-medium text-gray-800">Student Licences</p>
//                             <p className="text-[11px] text-gray-500">{studentCount} students x {fmt(summary.rate_student || 0)}/mo x {summary.avg_student_months || 12}mo</p>
//                           </div>
//                         </div>
//                         <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_student_cost)}</p>
//                       </div>
//                     </>
//                   )}
//                   {summary?.hub_storage?.total > 0 && (
//                     <div className="flex items-center justify-between p-3.5">
//                       <div className="flex items-center gap-3">
//                         <div className="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center"><Archive className="w-4 h-4 text-purple-500" /></div>
//                         <div>
//                           <p className="text-sm font-medium text-gray-800">DeskeyHUB Storage (Peak Usage)</p>
//                           <p className="text-[11px] text-gray-500">{summary.hub_storage.total_gb} GB x ₹{summary.hub_storage.rate_per_gb_month}/GB-month</p>
//                         </div>
//                       </div>
//                       <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.hub_storage.base_cost)}</p>
//                     </div>
//                   )}
//                   <div className="flex items-center justify-between p-3.5 bg-white">
//                     <p className="text-sm font-semibold text-gray-700">Subtotal (Taxable Amount)</p>
//                     <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_base_total + (summary?.hub_storage?.base_cost || 0))}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Right: GST Computation */}
//               <div className="space-y-4">
//                 <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider flex items-center gap-2">
//                   <Percent className="w-4 h-4 text-gray-500" />GST Computation
//                 </h3>
//                 <div className="bg-gray-50 rounded-xl border border-gray-100 divide-y divide-slate-100">
//                   <div className="flex items-center justify-between p-3.5">
//                     <p className="text-sm text-gray-700">Taxable Amount</p>
//                     <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_base_total)}</p>
//                   </div>
//                   <div className="flex items-center justify-between p-3.5">
//                     <p className="text-sm text-gray-700">CGST @ 9%</p>
//                     <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.cgst)}</p>
//                   </div>
//                   <div className="flex items-center justify-between p-3.5">
//                     <p className="text-sm text-gray-700">SGST @ 9%</p>
//                     <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.sgst)}</p>
//                   </div>
//                   <div className="flex items-center justify-between p-3.5 bg-white">
//                     <p className="text-sm font-bold text-gray-900">Total Payable to Desky</p>
//                     <p className="text-base font-extrabold tabular-nums" style={{ color: A }}>{fmt(summary.desky_payable)}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Monthly Breakdown */}
//             {summary.monthly_breakdown?.length > 0 && (
//               <div data-testid="monthly-breakdown">
//                 <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
//                   <Calendar className="w-4 h-4 text-gray-500" />Monthly Breakdown
//                 </h3>
//                 <div className="overflow-x-auto rounded-xl border border-gray-100">
//                   <table className="w-full text-sm">
//                     <thead>
//                       <tr className="bg-gray-50 border-b border-gray-100">
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Month</th>
//                         <th className="text-center py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Teachers</th>
//                         <th className="text-center py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Students</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Base Cost</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">GST (18%)</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Total</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-slate-50">
//                       {summary.monthly_breakdown.map(m => (
//                         <tr key={m.month} className="hover:bg-gray-50/60" data-testid={`month-${m.month}`}>
//                           <td className="py-3 px-4 text-sm font-medium text-gray-800">{new Date(m.month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</td>
//                           <td className="py-3 px-4 text-center text-sm text-gray-600">{m.teachers}</td>
//                           <td className="py-3 px-4 text-center text-sm text-gray-600">{m.students}</td>
//                           <td className="py-3 px-4 text-right text-sm font-medium text-gray-800 tabular-nums">{fmt(m.base_cost)}</td>
//                           <td className="py-3 px-4 text-right text-sm text-gray-500 tabular-nums">{fmt(m.gst)}</td>
//                           <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(m.total)}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}

//             {/* Earnings Card */}
//             {summary.school_markup_per_student > 0 && (
//               <div className="rounded-xl p-5 border" style={{ background: '#f5f3ff', borderColor: '#ede9fe' }}>
//                 <h3 className="text-sm font-bold uppercase tracking-wider mb-3 flex items-center gap-2" style={{ color: '#7c3aed' }}>
//                   <TrendingUp className="w-4 h-4" style={{ color: '#a78bfa' }} />Your Institution Earnings
//                 </h3>
//                 <div className="grid grid-cols-3 gap-4">
//                   <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
//                     <p className="text-[11px] text-violet-400 font-medium uppercase">Markup Rate</p>
//                     <p className="text-lg font-bold text-violet-700 mt-1">{fmt(summary.school_markup_per_student)}</p>
//                     <p className="text-[10px] text-violet-400">per student/month</p>
//                   </div>
//                   <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
//                     <p className="text-[11px] text-violet-400 font-medium uppercase">Student Months</p>
//                     <p className="text-lg font-bold text-violet-700 mt-1">{summary.total_student_months}</p>
//                     <p className="text-[10px] text-violet-400">billable months</p>
//                   </div>
//                   <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
//                     <p className="text-[11px] text-violet-400 font-medium uppercase">Total Earnings</p>
//                     <p className="text-lg font-bold text-violet-700 mt-1">{fmt(summary.school_markup_total)}</p>
//                     <p className="text-[10px] text-violet-400">your revenue</p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* No markup hint */}
//             {(!summary.school_markup_per_student || summary.school_markup_per_student === 0) && (
//               <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-50/60 border border-amber-100" data-testid="markup-hint">
//                 <AlertCircle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
//                 <div>
//                   <p className="text-sm font-semibold text-amber-800">No student markup configured</p>
//                   <p className="text-xs text-amber-600/80 mt-0.5">You can add an extra charge per student per month to earn on top of Desky's base cost. Go to <button onClick={() => setSettingsOpen(true)} className="underline font-semibold hover:text-amber-800">Settings</button> to configure.</p>
//                 </div>
//               </div>
//             )}

//             {/* Device Purchases */}
//             {summary.device_orders?.length > 0 && (
//               <div data-testid="device-orders-section">
//                 <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
//                   <Package className="w-4 h-4 text-gray-500" />Device Purchases
//                 </h3>
//                 <div className="overflow-x-auto rounded-xl border border-gray-100">
//                   <table className="w-full text-sm">
//                     <thead>
//                       <tr className="bg-gray-50 border-b border-gray-100">
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Order</th>
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Items</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Subtotal</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">GST (18%)</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Total</th>
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Date</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-slate-50">
//                       {summary.device_orders.map(o => (
//                         <tr key={o.id} className="hover:bg-gray-50/60" data-testid={`dev-order-${o.id}`}>
//                           <td className="py-3 px-4 text-xs font-mono text-gray-600">#{(o.id || '').slice(0, 8).toUpperCase()}</td>
//                           <td className="py-3 px-4">
//                             <div className="flex flex-wrap gap-1">
//                               {(o.items || []).map((item, i) => (
//                                 <span key={i} className="text-[11px] bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded">{item.name} x{item.quantity}</span>
//                               ))}
//                             </div>
//                           </td>
//                           <td className="py-3 px-4 text-right text-sm text-gray-700 tabular-nums">{fmt(o.subtotal)}</td>
//                           <td className="py-3 px-4 text-right text-[11px] text-gray-500 tabular-nums">{fmt(o.gst_amount)}</td>
//                           <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(o.total)}</td>
//                           <td className="py-3 px-4">
//                             <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold border ${o.status === 'delivered' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : o.status === 'shipped' ? 'bg-violet-50 text-violet-600 border-violet-100' : o.status === 'confirmed' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-amber-50 text-amber-600 border-amber-100'}`}>{(o.status || 'pending').toUpperCase()}</span>
//                           </td>
//                           <td className="py-3 px-4 text-sm text-gray-500">{fmtDate(o.created_at)}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                     <tfoot>
//                       <tr className="bg-gray-50/80 border-t border-gray-200">
//                         <td colSpan={2} className="py-3 px-4 text-sm font-semibold text-gray-700">Device Total ({summary.device_order_count} orders)</td>
//                         <td className="py-3 px-4 text-right text-sm font-semibold text-gray-800 tabular-nums">{fmt(summary.device_order_subtotal)}</td>
//                         <td className="py-3 px-4 text-right text-[11px] text-gray-500 tabular-nums">{fmt(summary.device_order_gst)}</td>
//                         <td className="py-3 px-4 text-right text-sm font-extrabold text-gray-900 tabular-nums">{fmt(summary.device_order_total)}</td>
//                         <td colSpan={2}></td>
//                       </tr>
//                     </tfoot>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ─── LINE ITEMS TAB ─── */}
//       {tab === 'line-items' && (
//         <div className="bg-white border border-gray-200 rounded-xl shadow overflow-hidden flex-1 min-h-0 flex flex-col" data-testid="invoices-table-container">
//           {/* Filters */}
//           <div className="px-5 py-3 border-b border-gray-100 flex-shrink-0">
//             <div className="flex items-center gap-2 flex-wrap">
//               <div className="relative flex-1 min-w-[200px]">
//                 <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
//                 <input value={liSearch} onChange={e => setLiSearch(e.target.value)} placeholder="Search by name or email..."
//                   className="w-full h-9 pl-9 pr-3 text-sm rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent bg-white placeholder:text-gray-300"
//                   style={{ '--tw-ring-color': `${A}30` }}
//                   data-testid="li-search" />
//               </div>
//               <div className="w-px h-6 bg-gray-200 mx-1" />
//               <div className="flex items-center gap-1.5">
//                 <Filter className="w-3.5 h-3.5 text-gray-500" />
//                 <select value={liRole} onChange={e => setLiRole(e.target.value)} className="h-9 text-xs rounded-lg border border-gray-200 px-2.5 bg-white text-gray-700 font-medium" data-testid="li-role-filter">
//                   <option value="all">All Roles</option>
//                   <option value="teacher">Teachers</option>
//                   <option value="student">Students</option>
//                 </select>
//                 <select value={liStatus} onChange={e => setLiStatus(e.target.value)} className="h-9 text-xs rounded-lg border border-gray-200 px-2.5 bg-white text-gray-700 font-medium" data-testid="li-status-filter">
//                   <option value="all">All Status</option>
//                   <option value="active">Active</option>
//                   <option value="expired">Expired</option>
//                 </select>
//               </div>
//               <span className="text-xs text-gray-500 font-medium ml-auto tabular-nums">{liTotal} users</span>
//             </div>
//           </div>

//           {/* Table */}
//           <div className="flex-1 overflow-y-auto min-h-0">
//             <table className="w-full text-sm" data-testid="invoices-table">
//               <thead className="sticky top-0 bg-gray-50/95 backdrop-blur-sm z-10 border-b border-gray-100">
//                 <tr>
//                   <th className="text-left px-4 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('name')}>
//                     User <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'name' ? 'text-gray-800' : 'text-gray-300'}`} />
//                   </th>
//                   <th className="text-left px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Role</th>
//                   <th className="text-center px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Months</th>
//                   <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('base')}>
//                     Base <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'base' ? 'text-gray-800' : 'text-gray-300'}`} />
//                   </th>
//                   <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Markup</th>
//                   <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">CGST</th>
//                   <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">SGST</th>
//                   <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('cost')}>
//                     Total <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'cost' ? 'text-gray-800' : 'text-gray-300'}`} />
//                   </th>
//                   <th className="text-left px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
//                   <th className="w-12 px-2 py-3"></th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-50">
//                 {sorted.length === 0 ? (
//                   <tr><td colSpan={10} className="text-center py-16 text-gray-500 text-sm">No billing records found</td></tr>
//                 ) : sorted.map(u => (
//                   <tr key={u.id} className="hover:bg-gray-50/60 transition-colors" data-testid={`inv-row-${u.id}`}>
//                     <td className="px-4 py-3">
//                       <div className="flex items-center gap-2.5">
//                         <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0" style={{ background: u.role === 'teacher' ? '#3b82f6' : '#10b981' }}>
//                           {(u.full_name || '?')[0].toUpperCase()}
//                         </div>
//                         <div className="min-w-0">
//                           <p className="text-sm font-medium text-gray-900 truncate max-w-[150px]">{u.full_name}</p>
//                           <p className="text-[11px] text-gray-500 truncate max-w-[150px]">{u.email}</p>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-3 py-3">
//                       <span className={`text-[11px] px-2.5 py-1 rounded-full font-semibold border ${u.role === 'teacher' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{u.role}</span>
//                     </td>
//                     <td className="px-3 py-3 text-center text-sm text-gray-700 tabular-nums font-medium">{u.licence_duration_months}</td>
//                     <td className="px-3 py-3 text-right text-sm text-gray-700 tabular-nums">{fmt(u.base_cost)}</td>
//                     <td className="px-3 py-3 text-right text-sm tabular-nums">
//                       {u.markup_total > 0 ? <span className="text-violet-600 font-medium">{fmt(u.markup_total)}</span> : <span className="text-gray-300">--</span>}
//                     </td>
//                     <td className="px-3 py-3 text-right text-[11px] text-gray-500 tabular-nums">{fmt(u.cgst)}</td>
//                     <td className="px-3 py-3 text-right text-[11px] text-gray-500 tabular-nums">{fmt(u.sgst)}</td>
//                     <td className="px-3 py-3 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(u.total_with_gst)}</td>
//                     <td className="px-3 py-3">
//                       {u.is_expired
//                         ? <span className="text-[11px] px-2.5 py-1 rounded-full font-semibold border bg-red-50 text-red-500 border-red-100">Expired</span>
//                         : <span className="text-[11px] px-2.5 py-1 rounded-full font-semibold border bg-emerald-50 text-emerald-600 border-emerald-100">Active</span>
//                       }
//                     </td>
//                     <td className="px-2 py-3">
//                       <button onClick={() => setSelectedUser(u)} className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors" data-testid={`inv-info-${u.id}`}>
//                         <Info className="w-4 h-4 text-gray-500" />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className="px-5 py-3 border-t border-gray-100 flex items-center justify-between flex-shrink-0 bg-gray-50/50">
//             <span className="text-xs text-gray-500 font-medium">Page {liPage} of {liTotalPages} ({liTotal} users)</span>
//             <div className="flex gap-1.5">
//               <button disabled={liPage <= 1} onClick={() => setLiPage(p => p - 1)} className="w-8 h-8 rounded-lg flex items-center justify-center border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-testid="li-page-prev">
//                 <ChevronLeft className="w-4 h-4 text-gray-600" />
//               </button>
//               <button disabled={liPage >= liTotalPages} onClick={() => setLiPage(p => p + 1)} className="w-8 h-8 rounded-lg flex items-center justify-center border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-testid="li-page-next">
//                 <ChevronRight className="w-4 h-4 text-gray-600" />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ─── PAYMENTS TAB ─── */}
//       {tab === 'payments' && (
//         <div className="bg-white border border-gray-200 rounded-xl shadow flex-1 min-h-0 overflow-y-auto" data-testid="payments-content">
//           <div className="p-5 space-y-5">
//             {/* Pay Now Card — plan fee (or per-seat pending dues for tier-based tenants) */}
//             {summary.pending_dues > 0 && (
//               <div className="rounded-xl overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }} data-testid="pay-now-card">
//                 <div className="p-6 flex items-center justify-between">
//                   <div>
//                     <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">
//                       {summary.billing_model === 'plan' ? `${summary.plan_name} Plan — Outstanding` : 'Outstanding Balance'}
//                     </p>
//                     <p className="text-3xl font-extrabold text-white tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{fmt(summary.pending_dues)}</p>
//                     <div className="flex items-center gap-3 mt-2 text-xs text-gray-500">
//                       <span>Base: {fmt(summary.desky_base_total)}</span>
//                       <span className="w-1 h-1 rounded-full bg-gray-500" />
//                       <span>GST: {fmt(summary.gst_total)}</span>
//                       <span className="w-1 h-1 rounded-full bg-gray-500" />
//                       <span>Paid: {fmt(summary.paid_total)}</span>
//                     </div>
//                   </div>
//                   <Button onClick={() => handlePayNow('plan')}
//                     className="h-11 px-7 rounded-xl text-sm font-bold bg-white text-gray-900 hover:bg-gray-100 shadow-lg"
//                     data-testid="pay-now-btn">
//                     <CreditCard className="w-4 h-4 mr-2" />
//                     Pay Now
//                   </Button>
//                 </div>
//                 <div className="px-6 pb-4">
//                   <div className="flex items-center gap-2 text-[11px] text-gray-600 bg-gray-800/50 rounded-lg px-3 py-2">
//                     <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" />
//                     <span>Online payments via Razorpay. Contact support if you need to pay via bank transfer.</span>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Extra licence dues — only ever non-zero for plan-based tenants */}
//             {summary.extra_licence_dues > 0 && (
//               <div className="rounded-xl overflow-hidden border border-amber-200 bg-amber-50" data-testid="pay-overage-card">
//                 <div className="p-5 flex items-center justify-between">
//                   <div>
//                     <p className="text-xs text-amber-700 uppercase tracking-wider font-semibold mb-1">Extra Licence Dues</p>
//                     <p className="text-2xl font-extrabold text-amber-800 tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{fmt(summary.extra_licence_dues)}</p>
//                     <p className="text-[11px] text-amber-600 mt-1">Licences created beyond your plan limit, prorated to renewal date.</p>
//                   </div>
//                   <Button onClick={() => handlePayNow('overage')}
//                     className="h-10 px-5 rounded-xl text-sm font-bold bg-amber-500 text-white hover:bg-amber-600 shadow"
//                     data-testid="pay-overage-btn">
//                     <CreditCard className="w-4 h-4 mr-2" />
//                     Pay Extra Licence Dues
//                   </Button>
//                 </div>
//               </div>
//             )}

//             {summary.pending_dues <= 0 && summary.extra_licence_dues <= 0 && (
//               <div className="rounded-xl p-6 text-center bg-emerald-50 border border-emerald-100" data-testid="all-paid-card">
//                 <CheckCircle2 className="w-10 h-10 text-emerald-400 mx-auto mb-2" />
//                 <p className="text-base font-bold text-emerald-700">All Clear</p>
//                 <p className="text-sm text-emerald-600/70 mt-1">No outstanding dues. Your account is fully paid up.</p>
//               </div>
//             )}

//             {/* Payment History */}
//             <div>
//               <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
//                 <CreditCard className="w-4 h-4 text-gray-500" />Payment History
//               </h3>
//               {payments.length === 0 ? (
//                 <div className="text-center py-12 border border-dashed border-gray-200 rounded-xl">
//                   <CreditCard className="w-8 h-8 text-gray-200 mx-auto mb-2" />
//                   <p className="text-sm text-gray-500 font-medium">No payment records yet</p>
//                   <p className="text-xs text-gray-300 mt-1">Payments will appear here once processed</p>
//                 </div>
//               ) : (
//                 <div className="overflow-x-auto rounded-xl border border-gray-100">
//                   <table className="w-full text-sm">
//                     <thead>
//                       <tr className="bg-gray-50 border-b border-gray-100">
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Receipt</th>
//                         <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Amount</th>
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
//                         <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Date</th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-slate-50">
//                       {payments.map(p => (
//                         <tr key={p.id || p.order_id} className="hover:bg-gray-50/60">
//                           <td className="py-3 px-4 text-sm font-mono text-gray-700">{p.receipt || p.order_id}</td>
//                           <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(p.amount)}</td>
//                           <td className="py-3 px-4">
//                             <span className={`text-[11px] px-2.5 py-1 rounded-full font-semibold border ${p.status === 'captured' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-amber-50 text-amber-600 border-amber-100'}`}>
//                               {p.status === 'captured' ? 'Paid' : p.status}
//                             </span>
//                           </td>
//                           <td className="py-3 px-4 text-sm text-gray-500">{fmtDate(p.captured_at || p.created_at)}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Receipt, Users, GraduationCap, BookOpen, TrendingUp, Calendar, Search, ArrowUpDown, IndianRupee, Clock, FileDown, Settings2, CreditCard, Info, X, ChevronLeft, ChevronRight, Mail, Phone, Percent, Building2, AlertCircle, CheckCircle2, Download, Filter, Package, Truck, Monitor, ExternalLink, ChevronDown, FileText, Archive } from '../DeskeyIcons';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { notifyError } from '../../lib/errors';

const API = process.env.REACT_APP_BACKEND_URL;

const STATUS_FALLBACK = {
  400: 'Bad request.',
  401: 'Please sign in again to continue.',
  402: 'Not enough Super Credits for this action.',
  403: "You don't have access to this resource.",
  404: 'Not found.',
  409: 'Conflict — please refresh and try again.',
  413: 'That file is too large.',
  422: 'Some inputs are invalid.',
  429: 'Too many requests — please slow down.',
  500: 'Server error. Please try again in a moment.',
  502: 'Upstream service is busy. Please retry.',
  503: 'Service temporarily unavailable.',
  504: 'Request timed out. Please retry.',
};

const api = async (path, opts = {}) => {
  const token = localStorage.getItem('desky_token');
  const res = await fetch(`${API}/api${path}`, { ...opts, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...opts.headers } });

  let text = '';
  try {
    text = await res.clone().text();
  } catch {
    try { text = await res.text(); } catch { text = ''; }
  }

  let body = null;
  if (text) {
    try { body = JSON.parse(text); }
    catch { body = { _raw: text }; }
  }

  if (!res.ok) {
    const detail =
      (body && (body.detail || body.message || body._raw)) ||
      STATUS_FALLBACK[res.status] ||
      `Request failed (${res.status})`;
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
};
const apiRaw = async (path) => {
  const token = localStorage.getItem('desky_token');
  return fetch(`${API}/api${path}`, { headers: { Authorization: `Bearer ${token}` } });
};

const fmt = (v) => `₹${(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '--';

/* ── Profile Info Modal ── */
function UserInfoModal({ person, accent, onClose }) {
  if (!person) return null;
  const A = accent;
  const Row = ({ icon: Icon, label, value }) => (
    <div className="flex items-center gap-3 py-3 px-1">
      <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${A}10` }}>
        <Icon className="w-4 h-4" style={{ color: A }} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] text-gray-500 font-medium uppercase tracking-wider">{label}</p>
        <p className="text-sm text-gray-900 font-medium truncate">{value || '--'}</p>
      </div>
    </div>
  );
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="billing-profile-modal">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="h-28 relative" style={{ background: `linear-gradient(135deg, ${A}, ${A}cc)` }}>
          <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors" data-testid="close-billing-modal"><X className="w-4 h-4 text-white" /></button>
        </div>
        <div className="flex justify-center -mt-14">
          <div className="w-28 h-28 rounded-full border-4 border-white shadow-lg flex items-center justify-center text-white text-3xl font-bold" style={{ background: A }}>{(person.full_name || '?')[0].toUpperCase()}</div>
        </div>
        <div className="text-center mt-3 px-6">
          <h3 className="text-lg font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>{person.full_name}</h3>
          <span className={`inline-block mt-1 text-[11px] px-3 py-0.5 rounded-full font-semibold border ${person.role === 'teacher' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{person.role}</span>
        </div>
        <div className="px-6 mt-3 space-y-0 divide-y divide-slate-100">
          <Row icon={Mail} label="Email" value={person.email} />
          <Row icon={Phone} label="Phone" value={person.phone} />
          <Row icon={Clock} label="Licence Duration" value={`${person.licence_duration_months} months`} />
          <Row icon={IndianRupee} label="Base Cost (Desky)" value={fmt(person.base_cost)} />
          {person.role === 'student' && person.markup_total > 0 && <Row icon={TrendingUp} label="Institution Markup" value={fmt(person.markup_total)} />}
          <Row icon={Percent} label="GST (18%)" value={`CGST ${fmt(person.cgst)} + SGST ${fmt(person.sgst)}`} />
          <Row icon={IndianRupee} label="Grand Total" value={fmt(person.total_with_gst)} />
          <Row icon={Calendar} label="Activated" value={fmtDate(person.activated_at)} />
          <Row icon={Calendar} label="Expires" value={fmtDate(person.expires_at)} />
        </div>
        <div className="px-6 pb-5 pt-4">
          <button onClick={onClose} className="w-full h-10 rounded-xl text-sm font-semibold text-gray-600 border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors" data-testid="close-profile-btn">Close</button>
        </div>
      </div>
    </div>
  );
}

/* ── Billing Settings Panel ── */
function BillingSettingsPanel({ settings, accent, onSave, onClose }) {
  const [form, setForm] = useState({ ...settings });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const handleSave = async () => {
    setSaving(true);
    await onSave(form);
    setSaving(false);
  };
  const fields = [
    { key: 'gstin', label: 'GSTIN Number', placeholder: 'e.g. 29AABCU9603R1ZM', desc: 'Your 15-digit GST Identification Number' },
    { key: 'billing_name', label: 'Legal Entity Name', placeholder: 'e.g. ABC School Trust', desc: 'Name as on GST registration' },
    { key: 'billing_address', label: 'Billing Address', placeholder: 'Street address', desc: null },
    { key: 'billing_city', label: 'City', placeholder: 'City', desc: null },
    { key: 'billing_state', label: 'State', placeholder: 'State', desc: null },
    { key: 'billing_pin', label: 'PIN Code', placeholder: '6-digit PIN', desc: null },
    { key: 'student_markup', label: 'Student Markup (per month)', placeholder: '0', type: 'number', desc: 'Extra amount you charge each student per month on top of Desky base cost' },
    { key: 'hsn_sac_code', label: 'HSN/SAC Code', placeholder: '998431', desc: 'Service classification code for invoicing' },
  ];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="billing-settings-modal">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in fade-in zoom-in-95 duration-200 max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10">
          <div>
            <h3 className="text-base font-bold text-gray-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Billing & GST Settings</h3>
            <p className="text-xs text-gray-500 mt-0.5">Configure your GST details and student markup</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center"><X className="w-4 h-4 text-gray-500" /></button>
        </div>
        <div className="px-6 py-5 space-y-4">
          {fields.map(f => (
            <div key={f.key}>
              <label className="text-xs font-semibold text-gray-700">{f.label}</label>
              {f.desc && <p className="text-[11px] text-gray-500 mt-0.5 mb-1">{f.desc}</p>}
              <input
                type={f.type || 'text'}
                value={form[f.key] || ''}
                onChange={e => set(f.key, f.type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
                placeholder={f.placeholder}
                className="w-full h-10 mt-1 px-3 text-sm rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent bg-white transition-shadow"
                style={{ '--tw-ring-color': `${accent}40` }}
                data-testid={`bs-${f.key}`}
              />
            </div>
          ))}
          <div className="bg-gray-50 rounded-xl p-4 mt-3 border border-gray-100">
            <p className="text-xs text-gray-600 font-semibold mb-2">Desky Base Rates (Fixed)</p>
            <div className="grid grid-cols-3 gap-3 text-sm">
              <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
                <p className="text-[10px] text-gray-500 font-medium">Teacher</p>
                <p className="text-sm font-bold text-gray-800">{fmt(settings.rate_teacher || 500)}<span className="text-[10px] text-gray-500 font-normal">/mo</span></p>
              </div>
              <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
                <p className="text-[10px] text-gray-500 font-medium">Student</p>
                <p className="text-sm font-bold text-gray-800">{fmt(settings.rate_student || 200)}<span className="text-[10px] text-gray-500 font-normal">/mo</span></p>
              </div>
              <div className="bg-white rounded-lg p-2.5 border border-gray-100 text-center">
                <p className="text-[10px] text-gray-500 font-medium">GST</p>
                <p className="text-sm font-bold text-gray-800">18%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky bottom-0 bg-white border-t border-gray-100 px-6 py-3 flex gap-3">
          <button onClick={onClose} className="flex-1 h-10 rounded-xl text-sm font-medium text-gray-600 border border-gray-200 hover:bg-gray-50 transition-colors">Cancel</button>
          <Button onClick={handleSave} disabled={saving} className="flex-1 h-10 rounded-xl text-sm font-semibold text-white shadow" style={{ background: accent }} data-testid="bs-save">
            {saving ? 'Saving...' : 'Save Settings'}
          </Button>
        </div>
      </div>
    </div>
  );
}

/* ── Stat Card ── */
function StatCard({ label, value, sub, icon: Icon, color, alert, testId }) {
  return (
    <div className={`bg-white border rounded-xl shadow p-4 flex flex-col justify-between transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 group ${alert ? 'border-red-200 bg-red-50/30' : 'border-gray-200'}`} data-testid={testId}>
      <div className="flex items-center justify-between mb-3">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${color}12` }}>
          <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.75} />
        </div>
        <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 text-right leading-tight max-w-[80px]">{label}</span>
      </div>
      <div>
        <p className="text-xl font-extrabold text-gray-900 tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{value}</p>
        <p className="text-[11px] text-gray-500 mt-0.5 truncate">{sub}</p>
      </div>
    </div>
  );
}

/* ── Storage Plan Change Dialog ── */
function StoragePlanDialog({ accent, plans, current, busy, onChoose, onClose }) {
  const A = accent;
  const options = [{ id: null, name: 'Free', quota_gb: 20, monthly_price: 0 }, ...plans];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="storage-plan-dialog">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-base font-bold text-gray-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Change storage plan</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center"><X className="w-4 h-4 text-gray-500" /></button>
        </div>
        <div className="px-6 py-4 space-y-2 max-h-[60vh] overflow-y-auto">
          <p className="text-xs text-gray-500 mb-2">
            Changes take effect on the 1st of next month, except your very first paid plan (activates immediately). Downgrades are blocked if you're using more than the target quota.
          </p>
          {options.map((p) => {
            const isCurrent = (current?.plan_id || null) === p.id;
            return (
              <button
                key={p.id || 'free'}
                onClick={() => onChoose(p.id)}
                disabled={busy || isCurrent}
                className={`w-full flex items-center justify-between p-3 rounded-xl border text-left transition-colors ${isCurrent ? 'border-emerald-200 bg-emerald-50' : 'border-gray-200 hover:bg-gray-50'} disabled:cursor-not-allowed`}
                data-testid={`storage-plan-option-${p.id || 'free'}`}
              >
                <div>
                  <p className="text-sm font-semibold text-gray-900">{p.name}</p>
                  <p className="text-[11px] text-gray-500">{p.quota_gb.toLocaleString('en-IN')} GB</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-bold text-gray-900 tabular-nums">{p.monthly_price > 0 ? `₹${p.monthly_price}/mo` : 'Free'}</p>
                  {isCurrent && <p className="text-[10px] text-emerald-600 font-semibold">Current</p>}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const TABS = [
  { id: 'overview', label: 'Overview', icon: Receipt },
  { id: 'line-items', label: 'Line Items', icon: Users },
  { id: 'payments', label: 'Payments', icon: CreditCard },
];

export function InvoicesSection({ accent }) {
  const A = accent || '#34A853';
  const [tab, setTab] = useState('overview');
  const [summary, setSummary] = useState(null);
  const [items, setItems] = useState([]);
  const [settings, setSettings] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Line items state
  const [liSearch, setLiSearch] = useState('');
  const [liRole, setLiRole] = useState('all');
  const [liStatus, setLiStatus] = useState('all');
  const [liPage, setLiPage] = useState(1);
  const [liTotal, setLiTotal] = useState(0);
  const [liTotalPages, setLiTotalPages] = useState(1);
  const [liSort, setLiSort] = useState('activated');
  const [liDir, setLiDir] = useState('desc');
  const [downloading, setDownloading] = useState(false);
  const [invoiceMenuOpen, setInvoiceMenuOpen] = useState(false);

  // Current year
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());

  // DeskeyHUB storage plan state
  const [storageStatus, setStorageStatus] = useState(null);
  const [storagePlans, setStoragePlans] = useState([]);
  const [storageDialogOpen, setStorageDialogOpen] = useState(false);
  const [changingPlan, setChangingPlan] = useState(false);

  const loadSummary = useCallback(async () => {
    const [s, bs] = await Promise.all([
      api('/institution/invoices/summary'),
      api('/institution/billing/settings'),
    ]);
    setSummary(s);
    setSettings(bs);
  }, []);

  const loadStorageStatus = useCallback(async () => {
    const s = await api('/institution/storage/status');
    setStorageStatus(s);
  }, []);

  const handleChangePlan = async (planId) => {
    setChangingPlan(true);
    try {
      const res = await api('/institution/storage/change-plan', { method: 'POST', body: JSON.stringify({ plan_id: planId }) });
      toast.success(res.message);
      setStorageDialogOpen(false);
      loadStorageStatus();
    } catch (e) {
      notifyError(e, 'Failed to change storage plan');
    }
    setChangingPlan(false);
  };

  const loadLineItems = useCallback(async () => {
    let url = `/institution/invoices/line-items?page=${liPage}&page_size=50`;
    if (liRole !== 'all') url += `&role=${liRole}`;
    if (liStatus !== 'all') url += `&status=${liStatus}`;
    if (liSearch) url += `&search=${encodeURIComponent(liSearch)}`;
    const res = await api(url);
    setItems(res.items || []);
    setLiTotal(res.total_count || 0);
    setLiTotalPages(res.total_pages || 1);
  }, [liPage, liRole, liStatus, liSearch]);

  const loadPayments = useCallback(async () => {
    const res = await api('/institution/billing/payments');
    setPayments(res.payments || []);
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([loadSummary(), loadLineItems(), loadPayments(), loadStorageStatus()]).finally(() => setLoading(false));
  }, [loadSummary, loadLineItems, loadPayments, loadStorageStatus]);

  useEffect(() => { if (!loading) loadLineItems(); }, [liPage, liRole, liStatus, liSearch]);
  useEffect(() => setLiPage(1), [liRole, liStatus, liSearch]);

  useEffect(() => {
    if (storageDialogOpen && storagePlans.length === 0) {
      api('/institution/storage/plans').then((r) => setStoragePlans(r.plans || [])).catch(() => {});
    }
  }, [storageDialogOpen, storagePlans.length]);

  const handleSaveSettings = async (form) => {
    await api('/institution/billing/settings', { method: 'PUT', body: JSON.stringify(form) });
    toast.success('Billing settings saved');
    setSettingsOpen(false);
    loadSummary();
    loadLineItems();
  };

  const downloadPDF = async (endpoint, filename) => {
    setDownloading(true);
    setInvoiceMenuOpen(false);
    try {
      const res = await apiRaw(endpoint);
      if (!res.ok) { toast.error('Failed to generate PDF'); setDownloading(false); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Invoice downloaded');
    } catch { toast.error('Download failed'); }
    setDownloading(false);
  };

  const handlePayNow = async (paymentType = 'plan') => {
    try {
      const due = paymentType === 'overage' ? summary?.extra_licence_dues : summary?.pending_dues;
      if (!summary || due <= 0) {
        toast.error(paymentType === 'overage' ? 'No extra licence dues to pay' : 'No pending dues to pay');
        return;
      }

      const user = JSON.parse(localStorage.getItem('desky_user') || '{}');

      const paymentData = await api(`/institution/billing/create-payment?payment_type=${paymentType}`, { method: 'POST' });

      const options = {
        key: paymentData.key_id,
        amount: paymentData.amount,
        currency: paymentData.currency,
        name: 'Deskey',
        description: paymentType === 'overage' ? 'Extra Licence Payment' : 'License & Storage Payment',
        order_id: paymentData.razorpay_order_id,
        handler: async (response) => {
          try {
            await api('/institution/billing/verify-payment', {
              method: 'POST',
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });
            toast.success('Payment successful!');
            loadSummary();
            loadPayments();
          } catch (err) {
            toast.error('Payment verification failed');
          }
        },
        prefill: {
          name: user.full_name || '',
          email: user.email || '',
        },
        theme: { color: '#3b82f6' },
        modal: {
          ondismiss: () => {
            toast.info('Payment cancelled');
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      if (err.status === 400 && err.body?.detail?.includes('not configured')) {
        toast.error('Razorpay payment gateway is not configured. Please contact Desky support.');
      } else {
        notifyError(err.body, 'Failed to initiate payment');
      }
    }
  };

  const sorted = useMemo(() => {
    let list = [...items];
    list.sort((a, b) => {
      let va, vb;
      if (liSort === 'name') { va = a.full_name || ''; vb = b.full_name || ''; }
      else if (liSort === 'cost') { va = a.total_with_gst || 0; vb = b.total_with_gst || 0; }
      else if (liSort === 'base') { va = a.base_cost || 0; vb = b.base_cost || 0; }
      else { va = a.activated_at || ''; vb = b.activated_at || ''; }
      if (va < vb) return liDir === 'asc' ? -1 : 1;
      if (va > vb) return liDir === 'asc' ? 1 : -1;
      return 0;
    });
    return list;
  }, [items, liSort, liDir]);

  const toggleSort = (col) => {
    if (liSort === col) setLiDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setLiSort(col); setLiDir('desc'); }
  };

  if (loading || !summary) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-120px)]" data-testid="invoices-loading">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-gray-200 border-t-slate-500 rounded-full animate-spin mx-auto mb-3" />
          <p className="text-sm text-gray-500">Loading billing data...</p>
        </div>
      </div>
    );
  }

  const teacherCount = summary.total_teachers || 0;
  const studentCount = summary.total_students || 0;

  return (
    <div className="flex flex-col gap-4 h-[calc(100vh-120px)]" data-testid="invoices-section">
      {selectedUser && <UserInfoModal person={selectedUser} accent={A} onClose={() => setSelectedUser(null)} />}
      {settingsOpen && settings && <BillingSettingsPanel settings={settings} accent={A} onSave={handleSaveSettings} onClose={() => setSettingsOpen(false)} />}
      {storageDialogOpen && (
        <StoragePlanDialog
          accent={A}
          plans={storagePlans}
          current={storageStatus}
          busy={changingPlan}
          onChoose={handleChangePlan}
          onClose={() => setStorageDialogOpen(false)}
        />
      )}

      {/* ── Top Stats Row ── */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 flex-shrink-0" data-testid="invoices-stat-cards">
        <StatCard label="Desky Dues" value={fmt(summary.desky_base_total)} icon={IndianRupee} color={A}
          sub={`${teacherCount}T + ${studentCount}S licensed`} testId="stat-desky-dues" />
        <StatCard label="GST 18%" value={fmt(summary.gst_total)} icon={Percent} color="#ef4444"
          sub={`CGST ${fmt(summary.cgst)} + SGST ${fmt(summary.sgst)}`} testId="stat-gst" />
        <StatCard label="Total Payable" value={fmt(summary.desky_payable)} icon={Receipt} color="#3b82f6"
          sub="Base + GST to Desky" testId="stat-total-payable" />
        <StatCard label="Earnings" value={fmt(summary.school_markup_total)} icon={TrendingUp} color="#8b5cf6"
          sub={summary.school_markup_per_student > 0 ? `${fmt(summary.school_markup_per_student)}/student/mo` : 'No markup set'} testId="stat-earnings" />
        <StatCard label="Pending" value={fmt(summary.pending_dues)} icon={CreditCard}
          color={summary.pending_dues > 0 ? '#ef4444' : '#10b981'}
          sub={summary.paid_total > 0 ? `Paid: ${fmt(summary.paid_total)}` : 'No payments yet'}
          alert={summary.pending_dues > 0} testId="stat-pending" />
      </div>

      {/* ── Tabs + Actions ── */}
      <div className="flex items-center gap-3 flex-shrink-0 flex-wrap">
        <div className="flex gap-1 bg-gray-100 rounded-xl p-1">
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all ${tab === t.id ? 'bg-white shadow text-gray-900' : 'text-gray-600 hover:text-gray-800'}`}
              data-testid={`inv-tab-${t.id}`}>
              <t.icon className="w-3.5 h-3.5" strokeWidth={tab === t.id ? 2 : 1.5} />
              {t.label}
            </button>
          ))}
        </div>
        <div className="ml-auto flex gap-2">
          <Button onClick={() => setSettingsOpen(true)} variant="outline" className="h-9 px-3.5 text-xs font-semibold rounded-lg border-gray-200 gap-1.5" data-testid="open-billing-settings">
            <Settings2 className="w-3.5 h-3.5" />Settings
          </Button>
          <div className="flex gap-2">
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="h-9 px-3 text-xs font-semibold rounded-lg border border-gray-200 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#34A853]"
              data-testid="year-selector"
            >
              <option value={currentYear.toString()}>{currentYear}</option>
              <option value={(currentYear - 1).toString()}>{currentYear - 1}</option>
            </select>
            <div className="relative">
              <Button onClick={() => setInvoiceMenuOpen(v => !v)} disabled={downloading} variant="outline" className="h-9 px-3.5 text-xs font-semibold rounded-lg border-gray-200 gap-1.5" data-testid="download-invoice-btn">
                <Download className="w-3.5 h-3.5" />{downloading ? 'Generating...' : 'Download'}<ChevronDown className="w-3 h-3 ml-0.5" />
              </Button>
            </div>
            {invoiceMenuOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setInvoiceMenuOpen(false)} />
                <div className="absolute right-0 top-11 z-50 w-72 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden animate-in fade-in zoom-in-95 duration-150" data-testid="invoice-download-menu">
                  {/* Full Licence Invoice */}
                  <div className="px-3 pt-3 pb-1.5">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Licence Invoices</p>
                  </div>
                  <button onClick={() => downloadPDF('/institution/billing/generate-invoice-pdf', 'desky_licence_invoice.pdf')}
                    className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-full-licence">
                    <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0"><FileText className="w-4 h-4 text-blue-500" /></div>
                    <div className="min-w-0"><p className="text-sm font-medium text-gray-800">Full Licence Invoice</p><p className="text-[11px] text-gray-500">All users, complete GST breakdown</p></div>
                  </button>

                  {/* Yearly */}
                  <div className="px-3 pt-3 pb-1.5 border-t border-gray-100">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Yearly</p>
                  </div>
                  <button onClick={() => downloadPDF(`/institution/billing/generate-invoice-pdf?period=${selectedYear}`, `desky_invoice_${selectedYear}.pdf`)}
                    className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-yearly">
                    <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center flex-shrink-0"><Calendar className="w-4 h-4 text-violet-500" /></div>
                    <div className="min-w-0"><p className="text-sm font-medium text-gray-800">{selectedYear} Annual Invoice</p><p className="text-[11px] text-gray-500">Full year summary</p></div>
                  </button>

                  {/* Device Purchases */}
                  {summary?.device_order_count > 0 && (
                    <>
                      <div className="px-3 pt-3 pb-1.5 border-t border-gray-100">
                        <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Device Purchases</p>
                      </div>
                      <button onClick={() => downloadPDF('/institution/billing/generate-device-invoice-pdf', 'desky_device_invoice.pdf')}
                        className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors" data-testid="dl-device-purchases">
                        <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0"><Monitor className="w-4 h-4 text-amber-500" /></div>
                        <div className="min-w-0"><p className="text-sm font-medium text-gray-800">Device Purchase Invoice</p><p className="text-[11px] text-gray-500">{summary.device_order_count} orders — {fmt(summary.device_order_total)}</p></div>
                      </button>
                    </>
                  )}

                  <div className="h-1.5" />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ─── OVERVIEW TAB ─── */}
      {tab === 'overview' && (
        <div className="bg-white border border-gray-200 rounded-xl shadow flex-1 min-h-0 overflow-y-auto" data-testid="overview-content">
          <div className="p-5 space-y-5">

            {/* Billing Summary Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              {/* Left: Cost Breakdown */}
              <div className="space-y-4">
                <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider flex items-center gap-2">
                  <IndianRupee className="w-4 h-4 text-gray-500" />Cost Breakdown
                </h3>
                <div className="bg-gray-50 rounded-xl border border-gray-100 divide-y divide-slate-100">
                  {summary.billing_model === 'plan' ? (
                    <>
                      <div className="flex items-center justify-between p-3.5">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center"><Package className="w-4 h-4 text-violet-500" /></div>
                          <div>
                            <p className="text-sm font-medium text-gray-800">{summary.plan_name} Plan</p>
                            <p className="text-[11px] text-gray-500">{fmt(summary.plan_price_per_license)}/licence x {(summary.plan_license_limit || 0).toLocaleString('en-IN')} licence limit</p>
                          </div>
                        </div>
                        <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.plan_total_cost)}</p>
                      </div>
                      <div className="flex items-center justify-between p-3.5">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center"><BookOpen className="w-4 h-4 text-blue-500" /></div>
                          <div>
                            <p className="text-sm font-medium text-gray-800">Teacher Licences</p>
                            <p className="text-[11px] text-gray-500">{teacherCount} teachers — always free</p>
                          </div>
                        </div>
                        <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(0)}</p>
                      </div>
                      <div className="flex items-center justify-between p-3.5">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center"><GraduationCap className="w-4 h-4 text-emerald-500" /></div>
                          <div>
                            <p className="text-sm font-medium text-gray-800">Licensed seats used</p>
                            <p className="text-[11px] text-gray-500">{summary.plan_licensed_count || 0} of {(summary.plan_license_limit || 0).toLocaleString('en-IN')}</p>
                          </div>
                        </div>
                      </div>
                      {summary.extra_licence_dues > 0 && (
                        <div className="flex items-center justify-between p-3.5">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center"><AlertCircle className="w-4 h-4 text-amber-500" /></div>
                            <div>
                              <p className="text-sm font-medium text-gray-800">Extra licence dues</p>
                              <p className="text-[11px] text-gray-500">Beyond plan limit, prorated to renewal</p>
                            </div>
                          </div>
                          <p className="text-sm font-bold text-amber-600 tabular-nums">{fmt(summary.extra_licence_dues)}</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="flex items-center justify-between p-3.5">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center"><BookOpen className="w-4 h-4 text-blue-500" /></div>
                          <div>
                            <p className="text-sm font-medium text-gray-800">Teacher Licences</p>
                            <p className="text-[11px] text-gray-500">{teacherCount} teachers x {fmt(summary.rate_teacher || 0)}/mo x {summary.avg_teacher_months || 12}mo</p>
                          </div>
                        </div>
                        <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_teacher_cost)}</p>
                      </div>
                      <div className="flex items-center justify-between p-3.5">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center"><GraduationCap className="w-4 h-4 text-emerald-500" /></div>
                          <div>
                            <p className="text-sm font-medium text-gray-800">Student Licences</p>
                            <p className="text-[11px] text-gray-500">{studentCount} students x {fmt(summary.rate_student || 0)}/mo x {summary.avg_student_months || 12}mo</p>
                          </div>
                        </div>
                        <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_student_cost)}</p>
                      </div>
                    </>
                  )}
                  {summary?.hub_storage?.total > 0 && (
                    <div className="flex items-center justify-between p-3.5">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center"><Archive className="w-4 h-4 text-purple-500" /></div>
                        <div>
                          <p className="text-sm font-medium text-gray-800">DeskeyHUB Storage — {summary.hub_storage.plan_name || 'Storage Plan'}</p>
                          <p className="text-[11px] text-gray-500">{summary.hub_storage.months_billed} months x ₹{summary.hub_storage.monthly_price}/mo</p>
                        </div>
                      </div>
                      <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.hub_storage.base_cost)}</p>
                    </div>
                  )}
                  <div className="flex items-center justify-between p-3.5 bg-white">
                    <p className="text-sm font-semibold text-gray-700">Subtotal (Taxable Amount)</p>
                    <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_base_total + (summary?.hub_storage?.base_cost || 0))}</p>
                  </div>
                </div>
              </div>

              {/* Right: GST Computation */}
              <div className="space-y-4">
                <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider flex items-center gap-2">
                  <Percent className="w-4 h-4 text-gray-500" />GST Computation
                </h3>
                <div className="bg-gray-50 rounded-xl border border-gray-100 divide-y divide-slate-100">
                  <div className="flex items-center justify-between p-3.5">
                    <p className="text-sm text-gray-700">Taxable Amount</p>
                    <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.desky_base_total)}</p>
                  </div>
                  <div className="flex items-center justify-between p-3.5">
                    <p className="text-sm text-gray-700">CGST @ 9%</p>
                    <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.cgst)}</p>
                  </div>
                  <div className="flex items-center justify-between p-3.5">
                    <p className="text-sm text-gray-700">SGST @ 9%</p>
                    <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(summary.sgst)}</p>
                  </div>
                  <div className="flex items-center justify-between p-3.5 bg-white">
                    <p className="text-sm font-bold text-gray-900">Total Payable to Desky</p>
                    <p className="text-base font-extrabold tabular-nums" style={{ color: A }}>{fmt(summary.desky_payable)}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* DeskeyHUB Storage Plan card */}
            {storageStatus && (
              <div className="bg-white border border-gray-200 rounded-xl p-4" data-testid="storage-plan-card">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider flex items-center gap-2">
                    <Archive className="w-4 h-4 text-gray-500" />DeskeyHUB Storage
                  </h3>
                  <Button onClick={() => setStorageDialogOpen(true)} variant="outline" className="h-8 px-3 text-xs font-semibold rounded-lg border-gray-200" data-testid="change-storage-plan-btn">
                    Change plan
                  </Button>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm font-semibold text-gray-800">{storageStatus.plan_name || 'Free'}</p>
                  <p className="text-sm font-bold text-gray-900 tabular-nums">{fmt(storageStatus.monthly_price)}/mo</p>
                </div>
                <div className="w-full h-2.5 rounded-full bg-gray-100 overflow-hidden">
                  <div
                    className={`h-full rounded-full ${storageStatus.used_gb > storageStatus.quota_gb ? 'bg-red-500' : 'bg-emerald-500'}`}
                    style={{ width: `${Math.min(100, (storageStatus.used_gb / (storageStatus.quota_gb || 1)) * 100)}%` }}
                  />
                </div>
                <p className={`text-[11px] mt-1.5 ${storageStatus.used_gb > storageStatus.quota_gb ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
                  {storageStatus.used_gb.toFixed(2)} GB used of {storageStatus.quota_gb.toLocaleString('en-IN')} GB
                  {storageStatus.used_gb > storageStatus.quota_gb && ' — over quota'}
                </p>
                {storageStatus.plan_status === 'pending_change' && (
                  <div className="mt-3 flex items-center gap-2 text-[11px] text-amber-700 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
                    <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" />
                    Switching to <strong>{storageStatus.pending_plan_name || 'Free'}</strong> on {storageStatus.next_effective_month}-01
                  </div>
                )}
              </div>
            )}

            {/* Monthly Breakdown */}
            {summary.monthly_breakdown?.length > 0 && (
              <div data-testid="monthly-breakdown">
                <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-gray-500" />Monthly Breakdown
                </h3>
                <div className="overflow-x-auto rounded-xl border border-gray-100">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-50 border-b border-gray-100">
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Month</th>
                        <th className="text-center py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Teachers</th>
                        <th className="text-center py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Students</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Base Cost</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">GST (18%)</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Total</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {summary.monthly_breakdown.map(m => (
                        <tr key={m.month} className="hover:bg-gray-50/60" data-testid={`month-${m.month}`}>
                          <td className="py-3 px-4 text-sm font-medium text-gray-800">{new Date(m.month + '-01').toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</td>
                          <td className="py-3 px-4 text-center text-sm text-gray-600">{m.teachers}</td>
                          <td className="py-3 px-4 text-center text-sm text-gray-600">{m.students}</td>
                          <td className="py-3 px-4 text-right text-sm font-medium text-gray-800 tabular-nums">{fmt(m.base_cost)}</td>
                          <td className="py-3 px-4 text-right text-sm text-gray-500 tabular-nums">{fmt(m.gst)}</td>
                          <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(m.total)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Earnings Card */}
            {summary.school_markup_per_student > 0 && (
              <div className="rounded-xl p-5 border" style={{ background: '#f5f3ff', borderColor: '#ede9fe' }}>
                <h3 className="text-sm font-bold uppercase tracking-wider mb-3 flex items-center gap-2" style={{ color: '#7c3aed' }}>
                  <TrendingUp className="w-4 h-4" style={{ color: '#a78bfa' }} />Your Institution Earnings
                </h3>
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
                    <p className="text-[11px] text-violet-400 font-medium uppercase">Markup Rate</p>
                    <p className="text-lg font-bold text-violet-700 mt-1">{fmt(summary.school_markup_per_student)}</p>
                    <p className="text-[10px] text-violet-400">per student/month</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
                    <p className="text-[11px] text-violet-400 font-medium uppercase">Student Months</p>
                    <p className="text-lg font-bold text-violet-700 mt-1">{summary.total_student_months}</p>
                    <p className="text-[10px] text-violet-400">billable months</p>
                  </div>
                  <div className="bg-white rounded-xl p-4 border border-violet-100 text-center">
                    <p className="text-[11px] text-violet-400 font-medium uppercase">Total Earnings</p>
                    <p className="text-lg font-bold text-violet-700 mt-1">{fmt(summary.school_markup_total)}</p>
                    <p className="text-[10px] text-violet-400">your revenue</p>
                  </div>
                </div>
              </div>
            )}

            {/* No markup hint */}
            {(!summary.school_markup_per_student || summary.school_markup_per_student === 0) && (
              <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-50/60 border border-amber-100" data-testid="markup-hint">
                <AlertCircle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-amber-800">No student markup configured</p>
                  <p className="text-xs text-amber-600/80 mt-0.5">You can add an extra charge per student per month to earn on top of Desky's base cost. Go to <button onClick={() => setSettingsOpen(true)} className="underline font-semibold hover:text-amber-800">Settings</button> to configure.</p>
                </div>
              </div>
            )}

            {/* Device Purchases */}
            {summary.device_orders?.length > 0 && (
              <div data-testid="device-orders-section">
                <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                  <Package className="w-4 h-4 text-gray-500" />Device Purchases
                </h3>
                <div className="overflow-x-auto rounded-xl border border-gray-100">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-50 border-b border-gray-100">
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Order</th>
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Items</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Subtotal</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">GST (18%)</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Total</th>
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Date</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {summary.device_orders.map(o => (
                        <tr key={o.id} className="hover:bg-gray-50/60" data-testid={`dev-order-${o.id}`}>
                          <td className="py-3 px-4 text-xs font-mono text-gray-600">#{(o.id || '').slice(0, 8).toUpperCase()}</td>
                          <td className="py-3 px-4">
                            <div className="flex flex-wrap gap-1">
                              {(o.items || []).map((item, i) => (
                                <span key={i} className="text-[11px] bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded">{item.name} x{item.quantity}</span>
                              ))}
                            </div>
                          </td>
                          <td className="py-3 px-4 text-right text-sm text-gray-700 tabular-nums">{fmt(o.subtotal)}</td>
                          <td className="py-3 px-4 text-right text-[11px] text-gray-500 tabular-nums">{fmt(o.gst_amount)}</td>
                          <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(o.total)}</td>
                          <td className="py-3 px-4">
                            <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold border ${o.status === 'delivered' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : o.status === 'shipped' ? 'bg-violet-50 text-violet-600 border-violet-100' : o.status === 'confirmed' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-amber-50 text-amber-600 border-amber-100'}`}>{(o.status || 'pending').toUpperCase()}</span>
                          </td>
                          <td className="py-3 px-4 text-sm text-gray-500">{fmtDate(o.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="bg-gray-50/80 border-t border-gray-200">
                        <td colSpan={2} className="py-3 px-4 text-sm font-semibold text-gray-700">Device Total ({summary.device_order_count} orders)</td>
                        <td className="py-3 px-4 text-right text-sm font-semibold text-gray-800 tabular-nums">{fmt(summary.device_order_subtotal)}</td>
                        <td className="py-3 px-4 text-right text-[11px] text-gray-500 tabular-nums">{fmt(summary.device_order_gst)}</td>
                        <td className="py-3 px-4 text-right text-sm font-extrabold text-gray-900 tabular-nums">{fmt(summary.device_order_total)}</td>
                        <td colSpan={2}></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── LINE ITEMS TAB ─── */}
      {tab === 'line-items' && (
        <div className="bg-white border border-gray-200 rounded-xl shadow overflow-hidden flex-1 min-h-0 flex flex-col" data-testid="invoices-table-container">
          {/* Filters */}
          <div className="px-5 py-3 border-b border-gray-100 flex-shrink-0">
            <div className="flex items-center gap-2 flex-wrap">
              <div className="relative flex-1 min-w-[200px]">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                <input value={liSearch} onChange={e => setLiSearch(e.target.value)} placeholder="Search by name or email..."
                  className="w-full h-9 pl-9 pr-3 text-sm rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent bg-white placeholder:text-gray-300"
                  style={{ '--tw-ring-color': `${A}30` }}
                  data-testid="li-search" />
              </div>
              <div className="w-px h-6 bg-gray-200 mx-1" />
              <div className="flex items-center gap-1.5">
                <Filter className="w-3.5 h-3.5 text-gray-500" />
                <select value={liRole} onChange={e => setLiRole(e.target.value)} className="h-9 text-xs rounded-lg border border-gray-200 px-2.5 bg-white text-gray-700 font-medium" data-testid="li-role-filter">
                  <option value="all">All Roles</option>
                  <option value="teacher">Teachers</option>
                  <option value="student">Students</option>
                </select>
                <select value={liStatus} onChange={e => setLiStatus(e.target.value)} className="h-9 text-xs rounded-lg border border-gray-200 px-2.5 bg-white text-gray-700 font-medium" data-testid="li-status-filter">
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="expired">Expired</option>
                </select>
              </div>
              <span className="text-xs text-gray-500 font-medium ml-auto tabular-nums">{liTotal} users</span>
            </div>
          </div>

          {/* Table */}
          <div className="flex-1 overflow-y-auto min-h-0">
            <table className="w-full text-sm" data-testid="invoices-table">
              <thead className="sticky top-0 bg-gray-50/95 backdrop-blur-sm z-10 border-b border-gray-100">
                <tr>
                  <th className="text-left px-4 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('name')}>
                    User <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'name' ? 'text-gray-800' : 'text-gray-300'}`} />
                  </th>
                  <th className="text-left px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Role</th>
                  <th className="text-center px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Months</th>
                  <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('base')}>
                    Base <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'base' ? 'text-gray-800' : 'text-gray-300'}`} />
                  </th>
                  <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Markup</th>
                  <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">CGST</th>
                  <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">SGST</th>
                  <th className="text-right px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider cursor-pointer select-none hover:text-gray-800" onClick={() => toggleSort('cost')}>
                    Total <ArrowUpDown className={`w-3 h-3 ml-1 inline-block ${liSort === 'cost' ? 'text-gray-800' : 'text-gray-300'}`} />
                  </th>
                  <th className="text-left px-3 py-3 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
                  <th className="w-12 px-2 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {sorted.length === 0 ? (
                  <tr><td colSpan={10} className="text-center py-16 text-gray-500 text-sm">No billing records found</td></tr>
                ) : sorted.map(u => (
                  <tr key={u.id} className="hover:bg-gray-50/60 transition-colors" data-testid={`inv-row-${u.id}`}>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2.5">
                        <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white flex-shrink-0" style={{ background: u.role === 'teacher' ? '#3b82f6' : '#10b981' }}>
                          {(u.full_name || '?')[0].toUpperCase()}
                        </div>
                        <div className="min-w-0">
                          <p className="text-sm font-medium text-gray-900 truncate max-w-[150px]">{u.full_name}</p>
                          <p className="text-[11px] text-gray-500 truncate max-w-[150px]">{u.email}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-3">
                      <span className={`text-[11px] px-2.5 py-1 rounded-full font-semibold border ${u.role === 'teacher' ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-emerald-50 text-emerald-600 border-emerald-100'}`}>{u.role}</span>
                    </td>
                    <td className="px-3 py-3 text-center text-sm text-gray-700 tabular-nums font-medium">{u.licence_duration_months}</td>
                    <td className="px-3 py-3 text-right text-sm text-gray-700 tabular-nums">{fmt(u.base_cost)}</td>
                    <td className="px-3 py-3 text-right text-sm tabular-nums">
                      {u.markup_total > 0 ? <span className="text-violet-600 font-medium">{fmt(u.markup_total)}</span> : <span className="text-gray-300">--</span>}
                    </td>
                    <td className="px-3 py-3 text-right text-[11px] text-gray-500 tabular-nums">{fmt(u.cgst)}</td>
                    <td className="px-3 py-3 text-right text-[11px] text-gray-500 tabular-nums">{fmt(u.sgst)}</td>
                    <td className="px-3 py-3 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(u.total_with_gst)}</td>
                    <td className="px-3 py-3">
                      {u.is_expired
                        ? <span className="text-[11px] px-2.5 py-1 rounded-full font-semibold border bg-red-50 text-red-500 border-red-100">Expired</span>
                        : <span className="text-[11px] px-2.5 py-1 rounded-full font-semibold border bg-emerald-50 text-emerald-600 border-emerald-100">Active</span>
                      }
                    </td>
                    <td className="px-2 py-3">
                      <button onClick={() => setSelectedUser(u)} className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors" data-testid={`inv-info-${u.id}`}>
                        <Info className="w-4 h-4 text-gray-500" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="px-5 py-3 border-t border-gray-100 flex items-center justify-between flex-shrink-0 bg-gray-50/50">
            <span className="text-xs text-gray-500 font-medium">Page {liPage} of {liTotalPages} ({liTotal} users)</span>
            <div className="flex gap-1.5">
              <button disabled={liPage <= 1} onClick={() => setLiPage(p => p - 1)} className="w-8 h-8 rounded-lg flex items-center justify-center border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-testid="li-page-prev">
                <ChevronLeft className="w-4 h-4 text-gray-600" />
              </button>
              <button disabled={liPage >= liTotalPages} onClick={() => setLiPage(p => p + 1)} className="w-8 h-8 rounded-lg flex items-center justify-center border border-gray-200 hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-testid="li-page-next">
                <ChevronRight className="w-4 h-4 text-gray-600" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── PAYMENTS TAB ─── */}
      {tab === 'payments' && (
        <div className="bg-white border border-gray-200 rounded-xl shadow flex-1 min-h-0 overflow-y-auto" data-testid="payments-content">
          <div className="p-5 space-y-5">
            {/* Pay Now Card — plan fee (or per-seat pending dues for tier-based tenants) */}
            {summary.pending_dues > 0 && (
              <div className="rounded-xl overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }} data-testid="pay-now-card">
                <div className="p-6 flex items-center justify-between">
                  <div>
                    <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">
                      {summary.billing_model === 'plan' ? `${summary.plan_name} Plan — Outstanding` : 'Outstanding Balance'}
                    </p>
                    <p className="text-3xl font-extrabold text-white tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{fmt(summary.pending_dues)}</p>
                    <div className="flex items-center gap-3 mt-2 text-xs text-gray-500">
                      <span>Base: {fmt(summary.desky_base_total)}</span>
                      <span className="w-1 h-1 rounded-full bg-gray-500" />
                      <span>GST: {fmt(summary.gst_total)}</span>
                      <span className="w-1 h-1 rounded-full bg-gray-500" />
                      <span>Paid: {fmt(summary.paid_total)}</span>
                    </div>
                  </div>
                  <Button onClick={() => handlePayNow('plan')}
                    className="h-11 px-7 rounded-xl text-sm font-bold bg-white text-gray-900 hover:bg-gray-100 shadow-lg"
                    data-testid="pay-now-btn">
                    <CreditCard className="w-4 h-4 mr-2" />
                    Pay Now
                  </Button>
                </div>
                <div className="px-6 pb-4">
                  <div className="flex items-center gap-2 text-[11px] text-gray-600 bg-gray-800/50 rounded-lg px-3 py-2">
                    <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" />
                    <span>Online payments via Razorpay. Contact support if you need to pay via bank transfer.</span>
                  </div>
                </div>
              </div>
            )}

            {/* Extra licence dues — only ever non-zero for plan-based tenants */}
            {summary.extra_licence_dues > 0 && (
              <div className="rounded-xl overflow-hidden border border-amber-200 bg-amber-50" data-testid="pay-overage-card">
                <div className="p-5 flex items-center justify-between">
                  <div>
                    <p className="text-xs text-amber-700 uppercase tracking-wider font-semibold mb-1">Extra Licence Dues</p>
                    <p className="text-2xl font-extrabold text-amber-800 tabular-nums tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>{fmt(summary.extra_licence_dues)}</p>
                    <p className="text-[11px] text-amber-600 mt-1">Licences created beyond your plan limit, prorated to renewal date.</p>
                  </div>
                  <Button onClick={() => handlePayNow('overage')}
                    className="h-10 px-5 rounded-xl text-sm font-bold bg-amber-500 text-white hover:bg-amber-600 shadow"
                    data-testid="pay-overage-btn">
                    <CreditCard className="w-4 h-4 mr-2" />
                    Pay Extra Licence Dues
                  </Button>
                </div>
              </div>
            )}

            {summary.pending_dues <= 0 && summary.extra_licence_dues <= 0 && (
              <div className="rounded-xl p-6 text-center bg-emerald-50 border border-emerald-100" data-testid="all-paid-card">
                <CheckCircle2 className="w-10 h-10 text-emerald-400 mx-auto mb-2" />
                <p className="text-base font-bold text-emerald-700">All Clear</p>
                <p className="text-sm text-emerald-600/70 mt-1">No outstanding dues. Your account is fully paid up.</p>
              </div>
            )}

            {/* Payment History */}
            <div>
              <h3 className="text-sm font-bold text-gray-800 uppercase tracking-wider mb-3 flex items-center gap-2">
                <CreditCard className="w-4 h-4 text-gray-500" />Payment History
              </h3>
              {payments.length === 0 ? (
                <div className="text-center py-12 border border-dashed border-gray-200 rounded-xl">
                  <CreditCard className="w-8 h-8 text-gray-200 mx-auto mb-2" />
                  <p className="text-sm text-gray-500 font-medium">No payment records yet</p>
                  <p className="text-xs text-gray-300 mt-1">Payments will appear here once processed</p>
                </div>
              ) : (
                <div className="overflow-x-auto rounded-xl border border-gray-100">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-50 border-b border-gray-100">
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Receipt</th>
                        <th className="text-right py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Amount</th>
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Status</th>
                        <th className="text-left py-3 px-4 text-[11px] font-bold text-gray-600 uppercase tracking-wider">Date</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {payments.map(p => (
                        <tr key={p.id || p.order_id} className="hover:bg-gray-50/60">
                          <td className="py-3 px-4 text-sm font-mono text-gray-700">{p.receipt || p.order_id}</td>
                          <td className="py-3 px-4 text-right text-sm font-bold text-gray-900 tabular-nums">{fmt(p.amount)}</td>
                          <td className="py-3 px-4">
                            <span className={`text-[11px] px-2.5 py-1 rounded-full font-semibold border ${p.status === 'captured' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-amber-50 text-amber-600 border-amber-100'}`}>
                              {p.status === 'captured' ? 'Paid' : p.status}
                            </span>
                          </td>
                          <td className="py-3 px-4 text-sm text-gray-500">{fmtDate(p.captured_at || p.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}